import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const AccordionWrapper = styled(Flexbox)`
  border-radius: 4px;
`;

export const AccordionHeader = styled(Flexbox)`
  cursor: pointer;
`;

export const AccordionBody = styled(Flexbox)``;
